<template>
    <div>
        <h3>
            {{ field.label }}
        </h3>
    </div>
</template>

<script>
export default {
    props: ['field'],
}
</script>
